import classNames from 'classnames';

const Badge = ({
  count = 0,
  success = true,
}: {
  count?: number;
  success?: boolean;
}) => {
  const classes = classNames({
    badge: true,
    'badge--success': !!success,
  });

  return <span className={classes}>{count}</span>;
};

export default Badge;
